import { openInNewTab } from '@strata/helper-functions';
import { FormContainer } from '@strata/react-form-container';
import { RadioButtonGroupFormik } from '@strata/react-radio-button-group';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import { useNavigate } from 'react-router';
import * as Yup from 'yup';

import {
    Application,
    ApplicationDisplayTextMap,
} from 'pages/homeScreenMessaging/HomeScreenHelpers';

export const HomeScreenPreviewSelection = () => {
    const navigate = useNavigate();
    return (
        <Formik
            initialValues={{}}
            validateOnMount
            validationSchema={Yup.object({
                application: Yup.string().required(validationStrings.requiredField.errorMessage),
            })}
            onSubmit={(values) => {
                openInNewTab(`/home-screen-messaging/preview/${values.application}`);
            }}
        >
            {(formik) => (
                <FormContainer
                    formTitle="Home Screen Preview"
                    primaryButtonLabel="Preview In New Tab"
                    onFormSubmit={formik.handleSubmit}
                    isSubmitting={!formik.isValid}
                    onSecondaryButtonClick={() => navigate('/home')}
                    formLeftContent={
                        <RadioButtonGroupFormik
                            name="application"
                            label="Application"
                            required
                            options={Object.values(Application)
                                .filter((app) => app !== Application.EXTERNAL)
                                .map((app) => ({
                                    value: app,
                                    text: ApplicationDisplayTextMap[app],
                                }))}
                        />
                    }
                />
            )}
        </Formik>
    );
};
